import { Component, Vue, Prop } from 'vue-property-decorator';

import { Dictionary } from '../../types/Dictionary';
import { MenuItemDTO } from '../../model/MenuItemDTO';
import { debounce } from '../../../node_modules/@types/lodash-es';

@Component({
	name: 'wms-menu-header-bottom'	// necessary because of https://github.com/kaorun343/vue-property-decorator/issues/102
})
export class WmsMenuHeaderBottom extends Vue {
	@Prop() menu: MenuItemDTO[];
	@Prop({ default: 0 }) parentId?: number;
	@Prop({ default: 0 }) level: number;
	@Prop({ default: false }) active: boolean;

	openedSubmenus: number[] = [];

	get classes() {
		const classes = [
			`mm-level-${this.level}`
		];

		if (this.level === 0) {
			classes.push('mm-menu-bottom');
		}

		if (this.active) {
			classes.push('active');
		}

		return classes;
	}

	get items(): any {
		if (!this.parentId) this.parentId = 0;

		const currentItems = this.menu
			.filter((item) => (item.parentId === this.parentId && (item.menuLevel == 2 || (item.menuLevel == 0 && item.parentId != 0)) && item.cssClass != "mm-separator-full")) //2 je druhá úroveň
			.sort((a, b) => a.order - b.order);

		var actualUrl = window.location.pathname;
		currentItems.forEach(function (currentItem) {
			var css = JSON.parse(JSON.stringify(currentItem.cssClass.replace('menu-top-visible', '').trim())).toString();

			currentItem.txtId = css
			currentItem.cssClassHref = css
			//console.log('label bottom:' + currentItem.label + " ::: " + currentItem.linkUrl+" ==>>> "+actualUrl);
		});

		return currentItems;
	}

	getItemStyle(item: MenuItemDTO) {
		const style: Dictionary<string> = {};

		if (item.decoration) {
			if (item.decoration.startsWith('#')) {
				style['background-color'] = item.decoration;
			} else {
				style['background-image'] = `url(${item.decoration})`;
			}
		}

		return style;
	}

	openSubmenu(item: MenuItemDTO, e: any) {
		//console.log(this.openedSubmenus)
		//$(".menu-top-visible").removeClass("menu-top-visible");

		var isMenuVisible = (item.cssClass.indexOf('menu-top-visible') >= 0)

		//console.log('cssclass (1)' + item.cssClass + '; id:' + item.txtId);
		item.cssClass = item.cssClass.replace("menu-top-visible", '').trim();
		//nutno zrušit vazbu na objekt....
		item.cssClassHref = JSON.parse(JSON.stringify(item.cssClass)).toString()
		item.txtId = item.cssClassHref;

		//schováme všechny položky menu
		this.menu.filter((f) => f.cssClass.indexOf('menu-top-visible') >= 0)
			.forEach(menuVisibleItem =>
				menuVisibleItem.cssClass = menuVisibleItem.cssClass.replace("menu-top-visible", '').trim()
			);

		//pokud není menu viditelné, zobrazíme jej
		if (!isMenuVisible) {
			item.cssClass = 'menu-top-visible ' + item.cssClass;
		}

		//console.log('cssclass (2)' + item.cssClass + '; id:' + item.txtId);


		if (this.menu.filter((f) => f.parentId === item.id).length > 0) {
			if (this.openedSubmenus.find(f => f === item.id)) {
				this.openedSubmenus = this.openedSubmenus.filter(f => f != item.id);
			}
			else {
				this.openedSubmenus = [];
				this.openedSubmenus.push(item.id);
				//this.openedSubmenus.push(item.id);
			}
		}
	}

	isActual(item: MenuItemDTO, e: any) {
		if (window.location.pathname == item.linkUrl) {
			return true;
		}

		return false;
	}
}

export default WmsMenuHeaderBottom;
